import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const createTake = (token, payload) =>
  axios.post(`${API}/practice/takes`, payload, auth(token)).then((r) => r.data);

export const updateTake = (token, takeId, payload) =>
  axios.post(`${API}/practice/takes/${takeId}`, payload, auth(token)).then((r) => r.data);

export const listTakes = (token) =>
  axios.get(`${API}/practice/takes`, auth(token)).then((r) => r.data);

export const getTake = (token, takeId) =>
  axios.get(`${API}/practice/takes/${takeId}`, auth(token)).then((r) => r.data);

export const deleteTake = (token, takeId) =>
  axios.delete(`${API}/practice/takes/${takeId}`, auth(token)).then((r) => r.data);

export const uploadVocal = (token, takeId, blob) =>
  axios.post(`${API}/practice/${takeId}/lanes/lyrics/upload-audio`, blob, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': blob.type || 'audio/webm' },
  }).then((r) => r.data);

export const analyzeTake = (token, takeId) =>
  axios.post(`${API}/practice/${takeId}/analyze`, {}, auth(token)).then((r) => r.data);

// AI demo meter — read-only quota for the countdown HUD + pay wall.
export const aiQuota = (token, app = 'trapworld') =>
  axios.get(`${API}/v1/ai/quota`, { params: { app }, ...auth(token) }).then((r) => r.data);

// Owner admin (server gates to ADMIN_USER_IDS — non-admins get 403).
export const adminAiUsers = (token, app) =>
  axios.get(`${API}/v1/admin/ai/users`, { params: { app }, ...auth(token) }).then((r) => r.data);

export const adminSetWindow = (token, app, seconds) =>
  axios.post(`${API}/v1/admin/ai/window`, { app, seconds }, auth(token)).then((r) => r.data);

// op: 'unlock' | 'lock' | 'reset' | 'add_minutes' (with minutes)
export const adminGrant = (token, payload) =>
  axios.post(`${API}/v1/admin/ai/grant`, payload, auth(token)).then((r) => r.data);

export const releaseTake = (token, takeId) =>
  axios.post(`${API}/practice/${takeId}/release`, {}, auth(token)).then((r) => r.data);

export const submitSigningDay = (token, takeId) =>
  axios.post(`${API}/practice/${takeId}/submit-signing-day`, {}, auth(token)).then((r) => r.data);

export const listBeats = (token) =>
  axios.get(`${API}/practice/beats`, auth(token)).then((r) => r.data);

export const practiceAudioUrl = (key) => `${API}/practice/audio/${key}`;

export { trendData } from './practiceTrend';
